/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
    Pipe,
    PipeTransform
} from '@angular/core';

@Pipe({
    name: 'JoinArrayStringsPipe',
    standalone: false
})
export class JoinArrayStringsPipe implements PipeTransform {
    transform(input: Array<string>, sep: string = ' | '): string {
        return input?.join(sep);
    }
}

